import React from 'react';
import PayPage from './pages/PayPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import TenantDashboard from './pages/tenant/Dashboard';
import LandlordDashboard from './pages/landlord/Dashboard';
import AdminDashboard from './pages/admin/Dashboard';
import AgentDashboard from './pages/agent/Dashboard';
import SuccessPage from './pages/SuccessPage';
import ZoomControl from './components/ZoomControl';
import ThemeToggle from './components/ThemeToggle';
import Navbar from './components/home/Navbar';
import Hero from './components/home/Hero';
import QuickPay from './components/home/QuickPay';
import RoleCards from './components/home/RoleCards';
import HowItWorks from './components/home/HowItWorks';
import Footer from './components/home/Footer';

function HomePage() {
  return (
    <div style={homeStyles.page}>
      <Navbar />
      <Hero />
      <QuickPay />
      <RoleCards />
      <HowItWorks />
      <Footer />
    </div>
  );
}

const DASHBOARD_PATHS = [
  '/tenant/dashboard',
  '/landlord/dashboard',
  '/admin/dashboard',
  '/agent/dashboard',
];

function App() {
  const path = window.location.pathname;
  const isHome = path === '/';
  const isDashboard = DASHBOARD_PATHS.includes(path);

  let page;
  if (isHome)                              page = <HomePage />;
  else if (path === '/pay')                page = <PayPage />;
  else if (path === '/success')            page = <SuccessPage />;
  else if (path === '/login')              page = <LoginPage />;
  else if (path === '/register')           page = <RegisterPage />;
  else if (path === '/forgot-password')    page = <ForgotPasswordPage />;
  else if (path === '/tenant/dashboard')   page = <TenantDashboard />;
  else if (path === '/landlord/dashboard') page = <LandlordDashboard />;
  else if (path === '/admin/dashboard')    page = <AdminDashboard />;
  else if (path === '/agent/dashboard')    page = <AgentDashboard />;
  else page = (
    <div style={notFoundStyles.page}>
      <div style={notFoundStyles.card}>
        <p style={notFoundStyles.icon}>🔍</p>
        <h2 style={notFoundStyles.title}>Page Not Found</h2>
        <p style={notFoundStyles.text}>
          The page you are looking for does not exist.
        </p>
        <a href="/" style={notFoundStyles.btn}>→ Go Home</a>
      </div>
    </div>
  );

  return (
    <>
      {page}
      {/* The home page has its own navbar, and every dashboard has its own
          AppShell topbar/sidebar — each with a built-in theme toggle and no
          zoom control. The floating globals only apply to the plain pages
          left over (login, register, pay, success, forgot-password, 404). */}
      {!isHome && !isDashboard && <ZoomControl />}
      {!isHome && !isDashboard && <ThemeToggle />}
    </>
  );
}

const homeStyles = {
  page: {
    minHeight: '100vh',
    backgroundColor: 'var(--color-bg)',
    fontFamily: 'var(--font-sans)',
    display: 'flex',
    flexDirection: 'column',
  },
};

const notFoundStyles = {
  page: {
    minHeight: '100vh',
    backgroundColor: 'var(--color-bg-alt)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Segoe UI, Arial, sans-serif',
  },
  card: {
    background: 'var(--color-surface)',
    borderRadius: '20px',
    padding: '48px 40px',
    textAlign: 'center',
    boxShadow: 'var(--shadow-md)',
    maxWidth: '360px',
    width: '100%',
  },
  icon: { fontSize: '48px', margin: '0 0 16px' },
  title: { fontSize: '24px', fontWeight: 700, margin: '0 0 12px', color: 'var(--color-ink)' },
  text: { fontSize: '14px', color: 'var(--color-muted)', margin: '0 0 28px', lineHeight: 1.6 },
  btn: {
    display: 'inline-block',
    padding: '14px 32px',
    backgroundColor: 'var(--color-brand)',
    color: 'var(--color-text-on-brand)',
    borderRadius: '12px',
    textDecoration: 'none',
    fontSize: '15px',
    fontWeight: 600,
  },
};

export default App;
